export default __webpack_public_path__ + "assets/logo-diamond-color-7b7caabff4fd83dad2e13d639317e22f.svg";